// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"94":"3b68454d61ed68520fd4","223":"aabf73eb72aadf5e8aca","679":"40ea29f5cd9cf90da206","774":"7e62b4eeb632b06fa65f"}[chunkId] + ".js";
};